import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FOUNDER_URL } from "../constants";
import { Reveal } from "./motion";

const Founder = () => (
  <section
    id="founder"
    data-testid="founder-section"
    className="relative overflow-hidden border-y hairline py-32 lg:py-40"
  >
    <div className="pointer-events-none absolute left-0 top-1/2 h-[36rem] w-[36rem] -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(212,175,55,0.12)_0%,transparent_65%)]" />

    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 lg:grid-cols-2 lg:gap-24 lg:px-12">
      <Reveal className="relative order-2 lg:order-1">
        <div className="relative">
          <div className="absolute -left-4 -top-4 h-full w-full border border-[#b8912e]/40" />
          <div className="absolute -bottom-6 -right-6 h-32 w-32 rounded-full border border-black/10" />
          <motion.div
            initial={{ clipPath: "inset(0 0 100% 0)" }}
            whileInView={{ clipPath: "inset(0 0 0% 0)" }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
            className="relative overflow-hidden"
          >
            <img
              src={FOUNDER_URL}
              alt="Amber Ellis, founder of The SEAL Collective"
              data-testid="founder-portrait"
              className="aspect-[4/5] w-full object-cover object-top"
            />
          </motion.div>
          <p className="mt-8 text-[0.6rem] font-light uppercase tracking-[0.4em] text-black/40">
            Amber Ellis — Founder
          </p>
        </div>
      </Reveal>

      <div className="order-1 lg:order-2">
        <Reveal>
          <p className="mb-6 text-[0.65rem] font-light uppercase tracking-[0.45em] text-[#8a6d1f]">
            Meet Amber Ellis
          </p>
          <h2
            data-testid="founder-headline"
            className="font-serif-display text-4xl font-light leading-[1.12] tracking-tight text-[#16130e] sm:text-5xl"
          >
            ONE WOMAN.
            <br />
            MANY DISCIPLINES.
            <br />
            <span className="text-gold-gradient">ONE THROUGH-LINE.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-10 space-y-6 text-sm font-extralight leading-relaxed text-black/60 md:text-base">
            <p>Amber’s work does not fit neatly inside one category — and that is intentional.</p>
            <p>
              Her background spans professional music and performance, sales leadership, corporate training,
              communication, entrepreneurship, spiritual exploration, sound, and emerging technology.
            </p>
            <p>Over time, those paths began revealing the same underlying question:</p>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <p
            data-testid="founder-keyline"
            className="font-serif-display mt-8 border-l border-[#b8912e]/50 pl-6 text-xl font-light italic leading-snug text-[#8a6d1f] md:text-2xl"
          >
            WHAT ACTUALLY CHANGES A HUMAN BEING FROM THE INSIDE?
          </p>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-8 space-y-6 text-sm font-extralight leading-relaxed text-black/60 md:text-base">
            <p>
              The SEAL Collective was created to explore that question across multiple forms — from a song, to
              a conversation, to a company, to a moment of stillness.
            </p>
            <p>
              The medium may change.{" "}
              <span className="text-black/85">THE HEART OF THE WORK DOES NOT.</span>
            </p>
          </div>
          <Link data-testid="founder-meet-amber-button" to="/amber-ellis" className="btn-outline mt-12">
            Meet Amber
          </Link>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Founder;
